import { z } from "zod/v4";

import { LoginResponseBodyRequestSchema } from "../../user-auths";

export const ShopifyLoginRequestBodySchema = z.object({
  shopId: z.string(),
});

export const ShopifyLoginResponseBodySchema = LoginResponseBodyRequestSchema;

export type ShopifyLoginRequestBodyType = z.infer<
  typeof ShopifyLoginRequestBodySchema
>;

export type ShopifyLoginResponseBodyType = z.infer<
  typeof ShopifyLoginResponseBodySchema
>;
